// AUTO-GENERATED by scripts/write-build-info.js — DO NOT EDIT.
// Regenerated at every `yarn start` and `yarn build`.
export const BUILD_COMMIT = "unknown";
export const BUILD_COMMITTED_AT = "2026-10-23T01:21:23.099Z";
export const BUILD_GENERATED_AT = "2026-10-23T01:21:23.100Z";
